var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.33329C14.341 7.33329 15.8334 5.84091 15.8334 3.99996C15.8334 2.15901 14.341 0.666626 12.5 0.666626M14.1667 17.3333H16.5C17.9728 17.3333 19.1667 16.1394 19.1667 14.6666C19.1667 12.4575 17.3758 10.6666 15.1667 10.6666H14.1667M10 3.99996C10 5.84091 8.50766 7.33329 6.66671 7.33329C4.82576 7.33329 3.33337 5.84091 3.33337 3.99996C3.33337 2.15901 4.82576 0.666626 6.66671 0.666626C8.50766 0.666626 10 2.15901 10 3.99996ZM3.50004 17.3333H9.83337C11.3061 17.3333 12.5 16.1394 12.5 14.6666C12.5 12.4575 10.7092 10.6666 8.50004 10.6666H4.83337C2.62423 10.6666 0.833374 12.4575 0.833374 14.6666C0.833374 16.1394 2.02728 17.3333 3.50004 17.3333Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIconDark);
export default __webpack_public_path__ + "static/media/users-icon-dark.b91c549b7358d91dbbd582bd4dfb3132.svg";
export { ForwardRef as ReactComponent };